import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TiposDeCuentaContableConstant from 'constants/tiposDeCuentaContable'
import ListaDeMonedasConstant from 'constants/listaDeMonedas'

const TipoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, values, setValues }) => {
  const changeHandler = React.useCallback(
    e => {
      handleChange(e)
      const selectedValue = e.target.value

      if (
        selectedValue === TiposDeCuentaContableConstant.ACTIVO_DISPONIBLE_EXIGIBLE ||
        selectedValue === TiposDeCuentaContableConstant.PASIVO
      ) {
        values.moneda = ListaDeMonedasConstant.SOLES
      }

      values.tipo = selectedValue
      setValues(values)
    },
    [handleChange, values, setValues]
  )

  return (
    <Form.Group>
      <Form.Label text='TIPO DE CUENTA' htmlFor='select-tipo' md={4} />
      <Col md={8}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Select
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={changeHandler}
              id='select-tipo'
            >
              <option value=''>Seleccionar</option>
              {TiposDeCuentaContableConstant.__array.map(x => (
                <option key={x.id} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
